import React from 'react';
import { muiHelpOutline } from '@ally/metronome-icons';
import { Dejargonator } from '../../../../Dejargonator';
import { AdornmentIcon } from './AdornmentIcon';
import { useFormTextStateProps } from '../../../context';
export var AdornmentDejarg = function (_a) {
    var heading = _a.heading, body = _a.body, triggerAriaLabel = _a.triggerAriaLabel, popoverAriaLabel = _a.popoverAriaLabel;
    var $isDisabled = useFormTextStateProps({}).$isDisabled;
    return (React.createElement(Dejargonator, { heading: heading, body: body, trigger: {
            variant: 'icon',
            content: React.createElement(AdornmentIcon, { icon: muiHelpOutline }),
            ariaLabel: triggerAriaLabel,
        }, popoverAriaLabel: popoverAriaLabel, disabled: $isDisabled }));
};
//# sourceMappingURL=AdornmentDejarg.js.map